import { render, staticRenderFns } from "./CreditDetail.vue?vue&type=template&id=3c708779&"
import script from "./CreditDetail.vue?vue&type=script&lang=js&"
export * from "./CreditDetail.vue?vue&type=script&lang=js&"
import style0 from "./CreditDetail.vue?vue&type=style&index=0&id=3c708779&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports